import { render, staticRenderFns } from "./SuppliesFormModal.vue?vue&type=template&id=4fd13ac3&"
import script from "./SuppliesFormModal.ts?vue&type=script&lang=js&"
export * from "./SuppliesFormModal.ts?vue&type=script&lang=js&"
import style0 from "./SuppliesFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports